export default __webpack_public_path__ + "static/media/human5.6e340191.png";